import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {errorInterceptor} from './core/interceptor/error-interceptor/error-interceptor';
import {providePrimeNG} from 'primeng/config';
import {MessageService as PrimeMessageService} from 'primeng/api';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {InputOtpModule} from 'primeng/inputotp';
import {OverlayModule} from '@angular/cdk/overlay';
import {provideCountdown} from 'ngx-countdown';
import {AuthInterceptor} from './core/interceptor/auth-interceptor/auth-interceptor';
import {MatDialogModule} from '@angular/material/dialog';
import Orange from '../custom-theme';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptors([errorInterceptor, AuthInterceptor])),
    providePrimeNG({
      theme: {
        preset: Orange,
        options: {
          darkModeSelector: '.dark'
        }
      }
    }),
    provideAnimationsAsync(),
    PrimeMessageService,
    InputOtpModule,
    OverlayModule,
    provideCountdown(),
    MatDialogModule
  ]
};
